/* global AWS:true */
export const AwsObject = (currentEnvironment) => {
  var config = {
    accessKeyId: currentEnvironment.s3AccessKeyId,
    secretAccessKey: currentEnvironment.s3SecretAccessKey
  }
  AWS.config.update(config)
  AWS.config.region = currentEnvironment.s3Region
  AWS.config.apiVersions = {
	  s3: '2006-03-01'
	}
}



// WEBPACK FOOTER //
// ./src/app/learningContent/aws.js